// Admin.js

import React, { useState, useEffect } from 'react'
import Subhead from '../Subhead'
import { useLocation, useNavigate } from 'react-router-dom'
import {
    allProjects,
    allusers,
    interestList,
    searchPlays,
    updateProject,
    uploadFilesmultie,
    allurl,
    addCommasToNumber,
    Allstamps,
} from '../../service/project'

import Searchwrap from '../../service/components/Searchwrap'
import Projectpgbox from '../Project/Projectpgbox'
import Swal from 'sweetalert2'
// ✅ 여기만 변경: 기존 AdminUser 대신 새 테이블 컴포넌트
import AdminUserPage from './AdminUserPage'
import AdminProject from './AdminProject'
import { imageArray } from '../../service/dataarray'

function Admin({ userId }) {
    const [selectedFiles, setSelectedFiles] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const path = location.pathname.split('/')[2]
    const searchParams = new URLSearchParams(location.search)
    const nums = searchParams.get('uid')
    const prevNumsRef = React.useRef(nums)

    const [projectlist, setProjectlist] = useState([])
    const [allP, setallp] = useState([])
    const [pg, setPgs] = useState()
    const [interest, setInterest] = useState([])
    const [edit, setEdit] = useState(false)
    const [uppg, setupPgs] = useState()
    const [searchText, setSearchText] = useState('')
    const [searchType, setSearchType] = useState(0)
    const [userlist, setUserlist] = useState('')
    const [alluserlist, setallUserlist] = useState('')
    const [sortArray, setSortArray] = useState({
        cate: [],
        minicate: [],
        adminstatus: [],
        moneystatus: [],
        prices: '',
        pricef: '',
        terms: '',
        termf: '',
        starts: '',
        startf: '',
    })

    const [filteredProjects, setFilteredProjects] = useState([])
    // ★ 추가: 전체 날인 리스트
    const [stamplist, setStamplist] = useState([])

    const searchTypes = (value) => {
        setSearchType(value)
    }
    const searchChange = (value) => {
        setSearchText(value)
    }

    // 검색 기능 (기존 그대로)
    const searchPlay = () => {
        searchPlays(allP, alluserlist, setProjectlist, setUserlist, path, searchType, searchText)
    }

    const uploadFiles = (projectId) => {
        uploadFilesmultie(projectId, selectedFiles)
    }

    const updates = () => {
        updateProject(
            uppg.title,
            uppg.email,
            uppg.company,
            uppg.cate,
            uppg.cateother,
            uppg.minicate,
            uppg.minicateother,
            uppg.outline,
            uppg.lastprojects,
            uppg.projects,
            uppg.needskill,
            uppg.price,
            uppg.startdate,
            uppg.term,
            uppg.contractcost,
            uppg.contractterm,
            uppg.pStatus,
            uppg.meet,
            uppg.client,
            uppg.clientphone,
            uppg.clientaddress,
            uppg.conditions,
            uppg.conditionother,
            uppg.uid,
        ).then(function (response) {
            if (response.data) {
                Swal.fire('성공적으로 수정되었습니다', '확인 버튼을 눌러 주세요', 'success')
                uploadFiles(response.data.id)
                const selectedFiless = selectedFiles
                    .map((fileObj) => {
                        return `${allurl}/file_uploads/${fileObj.fileName}`
                    })
                    .join(',')
                uppg.files = selectedFiless
                navigate(`/Admin/Adminproject?uid=${nums}`)
                setEdit(!edit)
                setPgs({ ...uppg })
            } else {
                Swal.fire('오류가 발생했습니다', '확인 버튼을 눌러 주세요', 'error')
            }
        })
    }

    const filterProjectList = (list, sortArr) => {
        const categoryFilters = ['cate', 'minicate', 'adminstatus', 'moneystatus']

        const filtered = list.filter((project) => {
            return categoryFilters.every((category) => {
                if (Array.isArray(sortArr[category]) && sortArr[category].length > 0) {
                    if (Array.isArray(project[category])) {
                        return project[category].some((item) => sortArr[category].includes(item))
                    } else {
                        return sortArr[category].includes(project[category])
                    }
                }
                return true
            })
        })

        return filtered
    }

    const handleChange = (category, itemName) => {
        if (category === 'cate' || category === 'adminstatus' || category === 'moneystatus') {
            const updatedSortArray = {
                ...sortArray,
                [category]: sortArray[category].includes(itemName)
                    ? sortArray[category].filter((item) => item !== itemName)
                    : [...sortArray[category], itemName],
            }

            setSortArray(updatedSortArray)
            const filtered = filterProjectList(allP, updatedSortArray)
            setProjectlist(filtered)
        } else if (category === 'minicate') {
            const updatedSortArray = {
                ...sortArray,
                [category]: sortArray[category].includes(itemName)
                    ? sortArray[category].filter((item) => item !== itemName)
                    : [...sortArray[category], itemName],
            }

            setSortArray(updatedSortArray)
            const filtered = filterProjectList(allP, updatedSortArray)
            setProjectlist(filtered)
        } else {
            setSortArray((prevState) => ({
                ...prevState,
                [category]: itemName,
            }))
        }
    }

    const handleChanges = (category, itemName) => {
        if (category === 'minicate' || category === 'conditions') {
            const updatedMinicate = uppg[category].includes(itemName)
                ? uppg[category].filter((item) => item !== itemName)
                : [...uppg[category], itemName]

            setupPgs((prevData) => ({
                ...prevData,
                [category]: updatedMinicate,
            }))
        } else if (category === 'price') {
            const numericValue = parseFloat(itemName.replace(/,/g, ''))

            if (!isNaN(numericValue)) {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: addCommasToNumber(numericValue),
                }))
            } else {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: '',
                }))
            }
        } else if (category === 'clientphone') {
            const numericValue = itemName.replace(/-/g, '')

            if (numericValue.length === 10) {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: numericValue.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
                }))
            } else if (numericValue.length === 11) {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: numericValue.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'),
                }))
            } else {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: itemName,
                }))
            }
        } else {
            setupPgs((prevState) => ({
                ...prevState,
                [category]: itemName,
            }))
        }
    }

    useEffect(() => {
        if (prevNumsRef.current && !nums) {
            window.location.reload()
        }

        prevNumsRef.current = nums
    }, [nums])

    useEffect(() => {
        // 전체 프로젝트 (기존 로직)
        allProjects()
            .then(function (response) {
                const saveListWithConvertedMinicate = response.data
                    .filter((v) => v.uid !== 'exampledata')
                    .map((item) => {
                        if (item.minicate) {
                            item.minicate = JSON.parse(item.minicate)
                            item.conditions = JSON.parse(item.conditions)
                        }
                        return item
                    })
                setallp(saveListWithConvertedMinicate)
                setProjectlist(saveListWithConvertedMinicate)

                const initialFilteredProjects = filterProjectList(saveListWithConvertedMinicate, sortArray)
                setFilteredProjects(initialFilteredProjects)
            })
            .catch(function (error) {
                console.log(error)
            })

        // 관심 프로젝트
        interestList(userId).then(function (response) {
            setInterest(response.data)
        })

        // 전체 유저
        allusers().then(function (response) {
            if (response.data) {
                setUserlist(response.data)
                setallUserlist(response.data)
            }
        })

        // ★ 전체 날인 리스트
        Allstamps()
            .then(function (res) {
                if (Array.isArray(res.data)) {
                    setStamplist(res.data)
                }
            })
            .catch(function (err) {
                console.log(err)
            })
    }, []) // 기존처럼 빈 배열 유지

    return (
        <div className="heightAuto">
            <div className="backback greyb"></div>
            <div className="project">
                <Subhead value={'ADMIN'} subvalue={'관리자페이지입니다'} img={imageArray.subtitle_portfolio} />
                <Searchwrap
                    searchTypes={searchTypes}
                    searchPlay={searchPlay}
                    searchChange={searchChange}
                    value={path == 'Adminproject' ? '전체 프로젝트 관리' : '회원현황'}
                />

                {path == 'Adminproject' ? (
                    <>
                        {!nums ? (
                            <AdminProject
                                handleChange={handleChange}
                                allP={allP}
                                projectlist={projectlist}
                                setProjectlist={setProjectlist}
                                interest={interest}
                                setInterest={setInterest}
                                userId={userId}
                            />
                        ) : nums ? (
                            <Projectpgbox
                                setSelectedFiles={setSelectedFiles}
                                admin={true}
                                setupPgs={setupPgs}
                                path={nums}
                                handleChange={handleChanges}
                                edit={edit}
                                pg={pg}
                                allpg={allP}
                                setPgs={setPgs}
                                uppg={uppg}
                                setallPg={setallp}
                                updates={updates}
                                setEdit={setEdit}
                                userId={userId}
                            />
                        ) : (
                            ''
                        )}
                    </>
                ) : path == 'Users' ? (
                    <AdminUserPage userlist={userlist} projectlist={projectlist} stamplist={stamplist} />
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}

export default Admin
